import {Component, computed, inject, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';

import {ACCEPTANCE_GROUP_KEY} from '../../../models/form-config.model';
import {DynamicFormService} from '../../../services/dynamic-form.service';
import {AcceptanceFieldComponent} from '../acceptance-field/acceptance-field.component';

/**
 * AcceptancesBlockComponent — blocco delle accettazioni globali.
 *
 * Renderizzato da DynamicFormComponent tra le categorie accordion
 * e il pulsante "Invia". Appare solo se `config.acceptances` è definito
 * e ha almeno un elemento.
 *
 * Ogni riga è un AcceptanceFieldComponent collegato al proprio FormControl
 * nel gruppo ACCEPTANCE_GROUP_KEY del rootGroup.
 */
@Component({
  selector: 'app-acceptances-block',
  standalone: true,
  imports: [ReactiveFormsModule, AcceptanceFieldComponent],
  templateUrl: './acceptances-block.component.html',
  styleUrl: './acceptances-block.component.scss',
})
export class AcceptancesBlockComponent {
  acceptancesSectionTitle = input<string>('Accettazioni e consensi');
  acceptancesSectionDescription = input<string>('');
  acceptancesSectionNote = input<string>('');

  protected readonly svc = inject(DynamicFormService);

  protected readonly acceptancesWithControls = computed(() => {
    const cfg = this.svc.config();
    const snapshot = this.svc.snapshot();
    const group = this.svc.getCategoryGroup(ACCEPTANCE_GROUP_KEY);

    if (!cfg?.acceptances || !group) return [];

    return cfg.acceptances
    .filter(acc => !acc.showIf || acc.showIf(snapshot))
    .map(acc => ({
      acc,
      control: group.get(acc.key) as any
    }));
  });
}
